import React, { useState } from 'react';
import './PasswordProtection.css';

function PasswordProtection({ onCorrectPassword }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_DEPLOYMENT_PASSWORD) {
      onCorrectPassword();
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  return (
    <div className="password-protection">
      <div className="password-container">
        <h2>Enter Password</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            className={error ? 'error' : ''}
          />
          {error && <div className="error-message">{error}</div>}
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default PasswordProtection; 